/** A single tab-switch button used in the App header (Estimator / Configuration). */

/** Header tabs in display order (arrow keys move through this order, wrapping). */
export const TAB_ORDER = ['calc', 'config'] as const;
export type TabId = (typeof TAB_ORDER)[number];

export interface TabButtonProps {
	id: TabId;
	label: string;
	active: boolean;
	onClick: (id: TabId) => void;
}

export function TabButton({ id, label, active, onClick }: TabButtonProps) {
	return (
		<button
			type="button"
			role="tab"
			id={`${id}-tab`}
			aria-selected={active}
			aria-controls={`${id}-panel`}
			tabIndex={active ? 0 : -1}
			onClick={() => onClick(id)}
			onKeyDown={(e) => {
				if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
					e.preventDefault();
					const step = e.key === 'ArrowRight' ? 1 : -1;
					const i = TAB_ORDER.indexOf(id);
					onClick(TAB_ORDER[(i + step + TAB_ORDER.length) % TAB_ORDER.length]);
				}
			}}
		>
			{label}
		</button>
	);
}
